// Copyright © 2021 Move Closer
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const breadcrumbsProps = {
    /**
     * Breadcrumbs list.
     */
    items: {
        type: Array,
        required: true
    },
    /**
     * Show breadcrumb on mobile screen
     */
    showOnMobile: {
        type: Boolean,
        required: false,
        default: false
    },
    /**
     * Root breadcrumb.
     */
    root: {
        type: Object,
        required: true
    }
};
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const breadcrumbsItemProps = {
    active: {
        type: Boolean,
        required: false,
        default: true
    },
    label: {
        type: String,
        required: true
    },
    target: {
        type: [String, Object],
        required: true
    }
};
